<div
  class="disclaimer"
  [ngClass]="color"
>
  <i [class]="'icon ic-md ' + icon"></i>
  <span class="text">
    <ng-content></ng-content>
  </span>
</div>
